export enum PlanModule 
{
    PROFILE = "profile",
    OFFICES = "offices",
    SERVICES = "services",
    DIRECTORY = "directory",
    SCHEDULE = "schedule",
    ONLINE_PAYMENT = "online_payment",
    CLINIC_HISTORY = "clinic_history",
    TELEMEDICINE = "telemedicine",
    DOC_DIRECT = "doc_direct",
    ORGANIZATION = "organization"
}

export const FREE_MODULES: PlanModule[] = [
    PlanModule.PROFILE,
    PlanModule.DIRECTORY,
    PlanModule.SCHEDULE
];
export const LITE_MODULES: PlanModule[] = [...FREE_MODULES,
    PlanModule.OFFICES,
    PlanModule.SERVICES,
    PlanModule.ONLINE_PAYMENT
];
export const COMPLETE_MODULES: PlanModule[] = [...LITE_MODULES, 
    PlanModule.CLINIC_HISTORY,
    PlanModule.TELEMEDICINE,
    PlanModule.DOC_DIRECT
];

export const PREMIUM_MODULES: PlanModule[] = [...COMPLETE_MODULES, PlanModule.ORGANIZATION];
